module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAOAgMAAAC9aL9dAAAACVBMVEUAAABOS0dPS0iPnR6RAAAAAnRSTlMAgnUlLzQAAAAYSURBVAjXY1gFAg4wCg8AK2mAUfgAqpkA+ZsUmRUZpSAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/images/nav-toggle.png
// module id = 688
// module chunks = 0 1 2 3 4 5 6 7 8